/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MailTopic {
  PrebidReminders = 'prebid_reminders',
  PrebidStatus = 'prebid_status',
  LotReminders = 'lot_reminders',
  ProxyBidOverview = 'proxy_bid_overview',
  BidResults = 'bid_results',
  ConsignmentResults = 'consignment_results'
}
